module.exports = __webpack_public_path__ + "static/media/New MG Logo (Icon).60aa8509.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/New MG Logo (Icon).png
// module id = 557
// module chunks = 0